import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Flame, Trophy, ArrowRight, Sparkles, Compass, BookOpen, FileSignature } from "lucide-react";

const ICONS = { Flame, Trophy, Sparkles, Compass, BookOpen, FileSignature };
const PILL = {
  amber: "bg-amber-100 text-amber-800",
  indigo: "bg-indigo-100 text-indigo-800",
  emerald: "bg-emerald-100 text-emerald-800",
  rose: "bg-rose-100 text-rose-800",
  orange: "bg-orange-100 text-orange-800",
  violet: "bg-violet-100 text-violet-800",
};

export default function StreakBadgeWidget() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/gamification").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;

  const earned = (data.badges || []).filter((b) => b.earned);
  const preview = earned.slice(-3);
  const empty = preview.length === 0;

  return (
    <div data-testid="streak-badge-widget" className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {/* Streak */}
      <div className="tactile-card p-6 md:col-span-1 bg-gradient-to-br from-rose-50 to-amber-50 border-rose-100">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-2xl bg-rose-500 text-white grid place-items-center">
            <Flame size={22} />
          </div>
          <div>
            <div data-testid="streak-count" className="text-3xl font-bold leading-none" style={{fontFamily:'Outfit'}}>
              {data.streak} {data.streak === 1 ? "day" : "days"}
            </div>
            <div className="text-xs uppercase tracking-widest font-bold text-slate-500 mt-1">Current streak</div>
          </div>
        </div>
        <div className="mt-3 text-sm text-slate-600">
          Longest: <strong>{data.longest_streak}</strong> day{data.longest_streak === 1 ? "" : "s"}
        </div>
      </div>

      {/* Badges */}
      <div className="tactile-card p-6 md:col-span-2">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-amber-100 text-amber-700 grid place-items-center">
              <Trophy size={18} />
            </div>
            <div>
              <div data-testid="badges-count" className="font-bold text-lg" style={{fontFamily:'Outfit'}}>
                {data.earned_count} / {data.total_badges} badges
              </div>
              <div className="text-xs uppercase tracking-widest font-bold text-slate-500">Collection</div>
            </div>
          </div>
          <Link to="/app/badges" data-testid="link-badges" className="text-sm font-bold text-indigo-700 inline-flex items-center gap-1">
            View all <ArrowRight size={14}/>
          </Link>
        </div>
        {empty ? (
          <p className="text-slate-500 text-sm" data-testid="badges-empty">
            Complete a coaching session to earn your first badge.
          </p>
        ) : (
          <div className="flex gap-3 flex-wrap">
            {preview.map((b) => {
              const Icon = ICONS[b.icon] || Trophy;
              return (
                <div key={b.id} title={b.desc}
                  data-testid={`mini-badge-${b.id}`}
                  className={`flex items-center gap-2 rounded-full ${PILL[b.color] || PILL.indigo} px-3 py-1.5 text-xs font-bold`}>
                  <Icon size={14}/> {b.name}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
